<template>
  <div class="container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row justify="center" dense>
      <v-col cols="12" sm="6" md="6">
        <v-card class="box" v-if="ay_std_div_list != null">
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong>Promote Student [Selected #{{selectedTasks.length}}]</strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-row justify="center" dense>
            <v-col sm="3">
              <v-icon color="error">*</v-icon>
              <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd()"
                @click="putnull" persistent-hint />
            </v-col>
            <v-col sm="3" v-if="std_div_list != null">
              <v-icon color="error">*</v-icon>
              <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" @click="putnull"
                persistent-hint />
            </v-col>
            <v-col sm="3" v-if="div_list != null">
              <v-icon color="error">*</v-icon>
              <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                item-text="div_name" label="Division" outlined @click="putnull" persistent-hint />
            </v-col>

            <v-col sm="2" v-if="sel_ay_data && sel_std_data">
              <v-btn class="mt-6 button" @click="getStudents()" :loading="fetch_loader">Fetch</v-btn>
            </v-col>
          </v-row>
          <span v-if="mainList != '' && mainList != null">
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>
              </v-card-title>
              <v-data-table show-select v-if="mainList.length > 0" :headers="headers" :items="mainList" :search="search"
                class="elevation-1" v-model="selectedTasks" :single-select="singleSelect" item-key="ldiv"
                :items-per-page="-1">
                <!-- <template v-slot:item.ispromoted="{ item }">
              <span v-if="item.ispromoted">
                <v-icon
                  class="mr-2 v-icon-size"
                  color="success"
                  title="Promoted"
                  >mdi-check-circle-outline</v-icon
                >
              </span>
              <span v-else>
                <v-icon
                  class="mr-2 v-icon-size"
                  color="error"
                  title="Not Promoted"
                  >mdi-close-circle-outline</v-icon
                >
              </span>
            </template> -->
              </v-data-table>
            </v-card>
            <!-- <v-card-actions class="justify-center">
          <v-btn
            color="primary darken-1"
            dark
            @click="promote_students"
            :loading="fetch_loader"
            >Promote Students</v-btn
          >
        </v-card-actions> -->
          </span>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="6" v-if="show_card">
        <v-card class="box">
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong>Promote Student</strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-row justify="center" dense>
            <v-col sm="3">
              <v-icon color="error">*</v-icon>
              <v-autocomplete color="#0F2027" dense rounded required v-model="academicyear" return-object
                :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStandard()"
                persistent-hint />
            </v-col>
            <v-col sm="3" v-if="standard_list != null">
              <v-icon color="error">*</v-icon>
              <v-autocomplete color="#0F2027" dense rounded required v-model="standard" return-object
                :items="standard_list" item-text="std" label="Standard" outlined @change="getDivision"
                persistent-hint />
            </v-col>
            <v-col sm="3" v-if="divoff_list != null">
              <v-icon color="error">*</v-icon>
              <v-autocomplete color="#0F2027" dense rounded required v-model="div_off" return-object
                :items="divoff_list" item-text="div_name" label="Division" outlined persistent-hint />
            </v-col>
          </v-row>
          <v-card-actions class="justify-center">
            <v-btn v-if="this.standard && this.div_off" color="primary darken-1" dark @click="promote_students"
              :loading="fetch_loader" :disabled="isConfirmed">Promote Students</v-btn>
          </v-card-actions>
          <v-data-table v-if="new_list.length > 0" :headers="headers" :items="new_list" :search="search"
            class="elevation-1" item-key="ldiv" :items-per-page="-1">
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div 
      v-if="showConfirmationDialog" 
      style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 9999;"
    >
      <div style="background: white; padding: 24px; border-radius: 8px; width: 400px; text-align: center; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
        <h3 style="margin-top: 0; margin-bottom: 16px; color: #333; font-size: 1.25rem;">
          Confirm Promotion
        </h3>
        
        <p style="color: #555; margin-bottom: 24px; font-size: 0.95rem; line-height: 1.5;">
          Are you sure you want to promote the student to the same standard?
        </p>
        
        <div style="display: flex; justify-content: space-between; gap: 16px;">
          <button 
            @click="showConfirmationDialog=false" 
            style="flex: 1; padding: 10px; border: 1px solid #d1d5db; background: white; color: #374151; border-radius: 4px; cursor: pointer; font-weight: bold;"
          >
            Cancel
          </button>
          
          <button 
            @click="confirmSameStandard" 
            style="flex: 1; padding: 10px; border: none; background: #283593; color: white; border-radius: 4px; cursor: pointer; font-weight: bold;"
          >
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    headers: [
      { text: "Roll Number", value: "rollnumber", align: "center" },
      { text: "Student Name", value: "studentname", align: "center" },
      { text: "Registration Number", value: "grnumber", align: "center" },
      //{ text: "Is Promoted", value: "ispromoted", align: "center" },
    ],
    singleSelect: false,
    fetch_loader: false,
    mainList: [], new_list: [],
    showConfirmationDialog:false,
    isConfirmed:false,

// extraBreadcrumbItems: [
         

//     ],
//     breadcrumbClass: "breadcrumb-style2",
    ay_std_div_list: null,
    std_div_list: null,
    standard_list:null,standard:"",divoff_list:null,div_off:"",ay_list:null,academicyear:"",show_card:false,
    selectedTasks: [],
    overlay: false,
    div_list: null,
    sel_std_data: null,
    divoff: "",
    studentinfo: "",
    ay: "",
    standard: "",
    division: "",
    dayno: "",
    search: "",
    atten_date: "",
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    editedIndex: {
      rollnumber: "",
      studentname: "",
      grnumber: "",
      totalpresent: "",
      ldiv: "",
    },
    nowDate: new Date().toISOString().slice(0, 10),
  }),

  mounted() {
    this.onload();
  },
  methods: {
    
    promote_students() {
      this.fetch_loader = true;
      this.overlay = true;
      const data = {
        selectedstudents: [],
        ay:this.academicyear.ay_id,
        standard:this.standard.std_id,
        div_off:this.div_off.div_off_id
      };
      var index = 0;
      this.selectedTasks.forEach(function (item) {
        data.selectedstudents[index] = item.ldiv;
        index++;
      });
      if(data.selectedstudents.length<=0){
         this.showSnackbar("#b71c1c", "Please Select Students...");
          this.fetch_loader = false;
            this.overlay=false;
         return
      }
      //alert("data.selectedstudents::"+data.selectedstudents)
     // return
      axios
        .post("/Admission/promote_students", data)
        .then((res) => {
          console.log(res.data);
          if (res.data.code == "SUCCESS") {
            //alert("Attendance Marked Successfully")
            this.showSnackbar("#4caf50", "Students promoted successfully..."); //res.data.status;
            this.selectedTasks=[]
           // this.getStudents();
            this.new_list = res.data.studentinfo;
            this.fetch_loader = false;
            this.overlay=false;
            //this.load=true
          } else {
            this.showSnackbar("#b71c1c", "Something Went wrong..!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
            this.overlay=false;
          }
        })
        .catch((error) => {
          this.fetch_loader = false;
          this.overlay=false;
          window.console.log(error);
        });
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
     getStandard() {
     // alert("ay---"+this.academicyear.ay_id)
      //alert("ay---"+this.sel_ay_data.ay_id)
      if(this.sel_ay_data.ay_id == this.academicyear.ay_id){
        this.showSnackbar("#b71c1c", "Select Different Academic Year..."); // show snackbar
        return
      }
      this.academicyear=this.academicyear
      this.standard_list = null;
      this.standard = null;
      this.divoff_list = null;
      this.div_off = null;
      this.standard_list = this.academicyear.std_list;
    },
    getDivision(){
      //  alert("sel_std_data---"+this.sel_std_data.std_id)
      //  alert("standard---"+this.standard.std_id)
       if(this.sel_std_data.std_id == this.standard.std_id){
        //this.showSnackbar("#b71c1c", "Select Different Standard..."); // show snackbar
        this.showConfirmationDialog=true;
        this.isConfirmed=true;
        //return 
      }else{
        this.isConfirmed=false;
      }
      
       //alert("standard---"+this.standard.div_list)
         this.standard=this.standard
         this.divoff_list = this.standard.div_list;
         this.div_off = this.divoff_list[0];
      if (this.divoff_list.length == 0) {
        alert("No division found!!!");
        this.divoff_list = null;
      }
      //alert("divoff_list--"+this.divoff_list);
    },
    getDiv() {
      this.div_list = this.sel_std_data.div_list;
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },

    confirmSameStandard(){
      this.showConfirmationDialog=false;
      this.div_off=null;
      this.isConfirmed=false;
    },
    
    putnull() {
      this.mainList = [];
      this.selectedTasks=[]
    },
    onload() {
      this.overlay = true;
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
          this.academicyear = res.data.sel_ay_data;
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getStudents() {
      this.selectedTasks=[]
      this.overlay = true;
      this.fetch_loader = true;
      const data = {
        divoff: this.div.div_off_id,
        ay:this.sel_ay_data.ay_id,
        standard:this.sel_std_data.std_id,
      };
      axios
        .post("/Admission/get_students_for_promote", data)
        .then((res) => {
          if (res.data.studentinfo.length != 0) {
            this.mainList = res.data.studentinfo;
            this.fetch_loader = false;
            this.overlay=false;
            this.show_card=true
          } else {
            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
            this.overlay=false;
          }
        })
        .catch((error) => {
          // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
          this.overlay=false;
        })
        .finally(() => {
          this.fetch_loader = false;
          this.overlay=false;
        });
    },
    editItem(item) {
      this.editedIndex = this.studentinfo.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$store.commit("setldiv_id", this.editedItem.ldiv);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  // watch: {
  //   date(val) {
  //     this.atten_date = this.formatDate(this.date);
  //   },
  // },
};
</script>
